import { FileRejection } from 'react-dropzone';

import { IFileErrorInfo } from 'interfaces/files';

const WRONG_FORMAT_ERROR = 'file-invalid-type';
const TOO_MANY_FILES_ERROR = 'too-many-files';
const FILE_TOO_LARGE = 'file-too-large';

export const getMessageByCode = ({ code, message }: { code: string; message: string }): string => {
  switch (code) {
    case WRONG_FORMAT_ERROR:
      return 'Invalid format';
    case TOO_MANY_FILES_ERROR:
      return 'Too many files';
    case FILE_TOO_LARGE: {
      const matches = message.match(/\d+/g);
      const sizeInBytes = matches ? parseInt(matches[0], 10) : 0;
      const sizeInMB = sizeInBytes / (1024 * 1024);
      return `${sizeInMB} MB max`;
    }
    default:
      return '';
  }
};

export const generateErrorsMessage = (fileRejections: FileRejection[]): IFileErrorInfo[] => {
  return fileRejections.reduce<IFileErrorInfo[]>((acc, curr) => {
    acc.push({ fileName: curr.file.name, errors: curr.errors.map(getMessageByCode) });
    return acc;
  }, []);
};
